module.exports = __webpack_public_path__ + "static/media/logo.d2785b78.png";